<template>
    <div>
		<loading id="spinner" :active="false" :can-cancel="false" :is-full-page="true"></loading>
        <div class="row">
            <div class="input-field col s4">
                <select  id="editalSelect" @change="getEnrollmentsByAnnouncementId()" >
                    <option value="" disabled >Selecione um Edital</option>
                    <option :value="edital.numero+'/'+edital.ano" :id="edital.id"
                    v-for="edital in filteredEdital" :key="edital.id" >
                        {{edital.numero+'/'+edital.ano}}
                    </option>
                </select>
            </div>
            <div class="input-field col s8">
                <i class="material-icons prefix ">search</i>
                <input id="search" type="text" class="validate" v-model="query" @input="getEnrollmentsByAnnouncementId()">
                <label for="search">Pesquisar</label>
            </div>
        </div>
        <div class="row">
            <div class="col s12 m12 l12 xl12">
                <table v-show="users && users.length > 0">
                    <thead>
                        <tr>
                            <th>
                                CPF
                            </th>
                            <th>
                                Nome
                            </th>
                            <th>
                                Ação
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(user,index) in users" :key="index">
                            <td>{{user.tax_id}}</td>
                            <td>{{user.name}}</td>
                            <td>
                                <table class="responsive-table">
                                    <tbody>
                                        <tr v-for="(enrollments,i) in  user.enrollments" :key="i">
                                            <td style="width:100%;">{{ enrollments.action.title }}</td>
                                            <td>
                                                <a title="Ver/editar inscrição" :href="'/inscricaos/ver/'+enrollments.id+''"
                                                    class="waves-effect waves-light btn-small">
                                                    <i class="material-icons">search</i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>

                        </tr>
                    </tbody>

                </table>

            </div>
        </div>
        <div class="row">
            <div class="card-action">
                <div class="row">
                    <div class="col s12">
                        <div class="left">
                            <strong>Total de registros por pagina</strong>
                            <select name="total_regs_pag"
                                    class="browser-default"
                                    style="width: auto;"
                                    id="total_regs_pag"
                                    @change="getEnrollmentsByAnnouncementId"
                                    v-model="paginate.per_page">
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="15">15</option>
                                <option value="50">50</option>
                            </select>
                        </div>

                        <div class="center">
                            <vuepaginate :totalPage="paginate.last_page"
                                            v-model="paginate.current_page"
                                            nextText="Próximo"
                                            prevText="Anterior"
                                            :withNextPrev="true"
                                            :customActiveBGColor="'#000099'"
                                            @btnClick="changePage"></vuepaginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import vuepaginate from "../utils/vuepaginate";

import moment from "moment";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const BASE_URL = "/api/enrollments";

export default {
    name:'VueDashboard',
    props:[
        'editais',

    ],
	components: {
         Loading,
         vuepaginate
    },
    data(){
        return {
            paginate: {
                per_page: 5,
                total: 0,
                current_page: 1,
                last_page : 1
            },
            users: [],
            isVisible:false,
            linkName:'Ver Ações',
            editaisData:JSON.parse(this.editais),
            sortProperty: 'CPF',
            sortDirection: 'asc',
            query: '',
            sortPropertyCPF: true,
            sortPropertyNome: false,
            sortPropertyQtd: false,
            returnUrl: '/dashboard',
            baseUrl : 'dashboard'

        }
    },
    computed:{
        filteredEdital:function(){

            return this.editaisData.map((edital)=>{
                let editalDate=moment(edital.fim_inscricao,'YYYYMMDD');
                let currentDate=moment(new Date().getDate(),'YYYYMMDD');
                if(editalDate.diff(currentDate) >=0){
                    edital=Object.assign({},edital,{aberto:true});

                }
                 return edital;

            });
        },
    },
    methods:{
        changePage(page){
            this.getEnrollmentsByAnnouncementId(page, false);
        },
        getEnrollmentsByAnnouncementId(page = 1, reset = true){
           if(reset)
               page = 1

            this.$set(this.paginate,'current_page', page);

            let announcementId = this._getSelectedAnnouncementId();
            const {per_page, total, current_page} = this.paginate;
            this.$http.get(`${BASE_URL}/${announcementId}`,{
                params : {
                    query:this.query,
                    announcementId,
                    per_page,
                    total,
                    page:current_page
                }

            })
            .then(({body}) => {

               this.$set(this.paginate,'per_page', Number.parseInt(body.meta.per_page));
               this.paginate.current_page = Number.parseInt(body.meta.current_page);
               this.paginate.last_page = Number.parseInt(body.meta.last_page);



               let data = body.data;

               let users = [];
               let enrollments = [];

               for(let i = 0; i < data.length; i++){
                   let usersflag = false;
                   let enrollmentsFlag = false;
                    const user = data[i]['user'];
                    const enrollment = data[i];

                    const newEnrollment = {
                        user_id : user['id'],
                        id: enrollment['id'],
                        action: enrollment['action']


                    };
                    if(enrollments.length == 0){
                        enrollments.push(newEnrollment);

                    }else{
                        for(let i = 0; i < enrollments.length; i++){
                            const enrollment = enrollments[i];
                            if(enrollment['id'] == newEnrollment['id']){
                                enrollmentsFlag = true;
                                break;
                            }
                        }
                        if(!enrollmentsFlag){
                            enrollments.push(newEnrollment);
                        }
                    }


                    if(users.length == 0){
                        users.push(user);
                    }
                    else{
                        for(let i = 0; i < users.length; i++){
                            const item = users[i];
                            if(item['id'] == user['id']){
                                usersflag = true;
                                break;
                            }
                        }
                        if(!usersflag){
                            users.push(user);
                        }

                    }

               }

                for(let i = 0; i < users.length; i++){
                    let user = users[i];
                    const enrollmentByUser = [];
                    for(let j = 0; j < enrollments.length; j++){
                        const enrollment = enrollments[j];
                        if(user['id'] == enrollment['user_id']){
                            enrollmentByUser.push(enrollment);
                        }
                    }
                    user['enrollments'] = enrollmentByUser;


                }
                this.$set(this,'users',users);

            })
            //.catch(error => console.error(error));


        },

        _getSelectedAnnouncementId(){
            const select = document.getElementById("editalSelect");
            return $(select).find('option:selected').attr('id');
        },



    },
    mounted(){

       this.getEnrollmentsByAnnouncementId();
    }

}
</script>